import { PartnerWithCategory } from '../types/types.ts';
import Button from './Button.tsx';
import QuestionnairePartnersByCategory from './QuestionnairePartnersByCategory.tsx';

interface QuestionnairePartnersContentProps {
  userSelectedPartners: PartnerWithCategory[];
  userSelectedCategories: string[];
  setUserSelectedPartners: (partners: PartnerWithCategory[]) => void;
  handleSubmitPartners: () => void;
}

const QuestionnairePartnersContent: React.FC<QuestionnairePartnersContentProps> = ({
  handleSubmitPartners,
  userSelectedPartners,
  setUserSelectedPartners,
  userSelectedCategories
}) => {
  const setPartner = (partner: PartnerWithCategory) => {
    if (userSelectedPartners.find(p => p.id === partner.id)) {
      setUserSelectedPartners(userSelectedPartners.filter(p => p.id !== partner.id));
      return;
    }
    setUserSelectedPartners([...userSelectedPartners, partner]);
  };

  return (
    <>
      <div className="vertical-scroll pb-4">
        <div className="ps-3 pe-2 pt-3 pb-4">
          <h2 className="font-yettel-bold fz-26">Šta te interesuje?</h2>
          <p className="font-yettel">Izaberi minimum 3 brenda ukupno iz svih kategorija.</p>
        </div>
        <div className="ps-2 pe-2 pt-2" onClick={e => e.stopPropagation()}>
          {userSelectedCategories.map(categoryId => (
            <QuestionnairePartnersByCategory
              key={categoryId}
              categoryId={categoryId}
              userSelectedPartners={userSelectedPartners}
              setPartner={setPartner}
            />
          ))}
        </div>
      </div>
      <div className="mb-2">
        <Button className="mt-2" disabled={userSelectedPartners.length < 3} onClick={handleSubmitPartners}>
          Nastavi
        </Button>

        <p className="text-center fz-14 pt-2 mb-2">Izabrano: {userSelectedPartners?.length}</p>
      </div>
    </>
  );
};

export default QuestionnairePartnersContent;
